import { Reducer } from 'redux'

import { LOGIN_ACTION, LoginAction } from 'actions/authorization/loginAction'
import {
  LOGOUT_ACTION,
  logoutPlainAction,
} from 'actions/authorization/logoutAction'
import {
  ADD_SEARCH_INTEREST,
  REMOVE_SEARCH_INTEREST,
  RESET_INITIAL_STATE,
  RESET_SEARCH_LIST,
  RESET_SEARCHING_SETTINGS,
  SAVE_MAIN_SEARCH_SETTINGS,
  UPDATE_LEGACY_LOCATION_FIELD,
  UPDATE_LOOK_FOR_FIELD_SETTINGS,
  UPDATE_SEARCH_SETTINGS_FIELD,
  UPDATE_SEARCH_SETTINGS_SECONDARY_FIELD,
  updateSearchSettingsFieldAction,
  updateLegacyLocationFieldAction,
  updateLookForFieldSettingsAction,
  updateSearchSettingsSecondaryFieldPlainAction,
  saveSettingsMainSearchPlainAction,
  resetSearchListAction,
  addSearchInterestAction,
  removeSearchInterestAction,
  resetSearchSettingsPlainAction,
  resetInitialStateAction,
  resetCurrentFormAction,
  RESET_CURRENT_FORM,
} from 'actions/mainSearchAction'
import {
  fetchSearchSettingsListAction,
  FETCH_SEARCH_SETTINGS_LIST,
} from 'actions/search/fetchSearchSettingsListAction'
import {
  GET_SEARCH_LIST,
  GetSearchListAction,
} from 'actions/search/searchAction'
import { ProfileItem, SearchListApi } from 'api/search/search.types'
import { DeprecatedApi6Error } from 'api/types'
import { locationField } from 'common/constants'
import { defaultSearchForm } from 'components/page/MainSearchSettings/constants'
import { whoAreNearField } from 'components/page/MainSearchSettings/FormFieldsStatic'
import { advancedSearchRestrictedBackendId } from 'components/uninotice/uniNoticeIdList'
import { isServerError } from 'functions/api/isServerError'
import { concatLocationName } from 'functions/client'
import { defaultPromiseReducer } from 'reducers/defaultPromiseReducer'
import { formOptionsUpdate } from 'reducers/search/formOptionsUpdate'
import { injectSearchResult } from 'reducers/search/mainSeachReducer.functions'
import { initialState, MainSearchState } from 'reducers/search/MainSearchState'

export const mainSearchReducer: Reducer<
  MainSearchState,
  MainSearchReducerActionTypes | LoginAction | GetSearchListAction
> = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SEARCH_SETTINGS_LIST:
      return defaultPromiseReducer(
        state,
        action,
        () => {
          return {
            ...state,
            searchSettingsLoading: true,
          }
        },
        (result) => formOptionsUpdate(result)
      )

    case UPDATE_SEARCH_SETTINGS_FIELD: {
      const { value, name, field } = action

      if (value) {
        const formField = state.form[field] as Array<string | number>
        return {
          ...state,
          form: {
            ...state.form,

            [field]: formField.concat(name),
          },
        }
      } else {
        const formField = state.form[field] as Array<string | number>
        return {
          ...state,
          form: {
            ...state.form,
            [field]: formField.filter((item) => item !== name),
          },
        }
      }
    }

    // TODO выпилить после того как в настройках поиска перестанет приходить location = 0_0_0_0
    case UPDATE_LEGACY_LOCATION_FIELD:
      return {
        ...state,
        form: {
          ...state.form,
          location: action.location,
        },
      }

    case UPDATE_LOOK_FOR_FIELD_SETTINGS: {
      const { value, field } = action

      const newState = {
        ...state,
        form: {
          ...state.form,
          [field]: value,
        },
      }

      return newState
    }

    case UPDATE_SEARCH_SETTINGS_SECONDARY_FIELD: {
      const { value, field, itemLocation } = action

      if (
        field === whoAreNearField ||
        field === 'withPhoto' ||
        field === 'period' ||
        field === 'myGender'
      ) {
        return {
          ...state,
          form: {
            ...state.form,
            [field]: value,
          },
        }
      }

      if (field === locationField) {
        if (itemLocation) {
          itemLocation.locationString = concatLocationName(itemLocation)

          return {
            ...state,
            form: {
              ...state.form,
              whoAreNear: false,
              [field]: value as string,
              currentLocation: itemLocation,
            },
            currentLocationAutocomplete: itemLocation,
          }
        }

        return {
          ...state,
          form: {
            ...state.form,
            whoAreNear: false,
            [field]: value as string,
          },
        }
      }

      return {
        ...state,
        form: {
          ...state.form,
          [field]: Number(value),
        },
      }
    }

    case GET_SEARCH_LIST: {
      const { result } = action

      return defaultPromiseReducer(
        state,
        action,
        () => ({
          resultLoaded: false,
          resultLoading: true,
          searchListFetchingServerError: false,
        }),
        () => {
          const items: ProfileItem[] = result!.items.map((item) => ({
            ...item,
            cursor: action.cursor,
          }))

          return {
            searchResult: injectSearchResult(
              items,
              result as SearchListApi,
              state
            ),
            resultLoaded: true,
            resultLoading: false,
            firstLoaded: true,
            hasErrorAdvancedSearch: false,
            searchListFetchingServerError: false,
          }
        },
        (result, state, error, errorStatus) => {
          return {
            firstLoaded: true,
            resultLoaded: false,
            resultLoading: false,
            // isEnd: true, // isEnd есть только в курсоре
            hasErrorAdvancedSearch:
              (result as unknown as DeprecatedApi6Error)?.internalError
                ?.code === advancedSearchRestrictedBackendId,
            searchListFetchingServerError: isServerError(errorStatus),
          }
        }
      )
    }

    case SAVE_MAIN_SEARCH_SETTINGS:
      return defaultPromiseReducer(
        state,
        action,
        () => ({
          formSaving: true,
          formSaved: false,
        }),
        () => ({
          formSaving: false,
          formSaved: true,
          defaultStateForm: {
            ...state.form,
          },
        }),
        () => ({
          formSaving: false,
          formSaved: false,
        })
      )

    case RESET_SEARCH_LIST:
    case LOGIN_ACTION:
    case LOGOUT_ACTION:
      return {
        ...state,
        resultLoaded: false,
        resultLoading: false,
        firstLoaded: false,
        searchResult: {
          ...state.searchResult,
          items: [],
          serverItemsCount: 0,
          isEnd: false,
          cursor: {
            negativeTags: null,
            searchId: 0,
            searcherOffset: 0,
            type: null,
          },
        },
      }

    case ADD_SEARCH_INTEREST:
      if (state.form.interests.includes(action.interest.id)) {
        return state
      }
      return {
        ...state,
        form: {
          ...state.form,
          interests: [action.interest.id],
        },
        interests: [action.interest],
      }

    case REMOVE_SEARCH_INTEREST:
      return {
        ...state,
        form: {
          ...state.form,
          interests: state.form.interests.filter((id) => action.value !== id),
        },
        interests: state.interests.filter(({ id }) => action.value !== id),
      }

    case RESET_SEARCHING_SETTINGS:
      return defaultPromiseReducer(
        state,
        action,
        () => ({ settingsReseting: true }),
        () => ({
          settingsReseting: false,
          settingsReseted: true,
          errorCode: '',
        }),
        () => ({
          settingsReseting: false,
          settingsReseted: false,
        })
      )

    case RESET_INITIAL_STATE:
      return {
        ...state,
        defaultStateForm: defaultSearchForm,
      }

    case RESET_CURRENT_FORM:
      return {
        ...state,
        form: {
          ...state.defaultStateForm,
        },
        interests: [],
      }

    default:
      return state
  }
}

type MainSearchReducerActionTypes =
  | ReturnType<typeof fetchSearchSettingsListAction>
  | ReturnType<typeof updateSearchSettingsFieldAction>
  | ReturnType<typeof updateLegacyLocationFieldAction>
  | ReturnType<typeof updateLookForFieldSettingsAction>
  | ReturnType<typeof updateSearchSettingsSecondaryFieldPlainAction>
  | ReturnType<typeof saveSettingsMainSearchPlainAction>
  | ReturnType<typeof resetSearchListAction>
  | ReturnType<typeof logoutPlainAction>
  | ReturnType<typeof addSearchInterestAction>
  | ReturnType<typeof removeSearchInterestAction>
  | ReturnType<typeof resetSearchSettingsPlainAction>
  | ReturnType<typeof resetInitialStateAction>
  | ReturnType<typeof resetCurrentFormAction>
